module.exports = __webpack_public_path__ + "img/thumbnail_HighlandCattle_f_normal.8e77642f.png";